<template>
	<a-card class="QuestionnaireManage">
		<a-form-model layout="inline">
			<a-form-model-item label="问卷名称">
				<a-input placeholder="请输入问卷名称" :maxLength="20" v-model="search.Name"/>
			</a-form-model-item>
			<a-form-model-item label="能力维度">
				<a-cascader v-model="selectId"
							style="width: 250px;"
							:options="options"
							:load-data="loadData"
							placeholder="请选择能力维度"
							change-on-select
							@change="onChange"/>
			</a-form-model-item>
			<a-form-model-item label="年龄段">
				<a-input-group compact>
					<a-input-number style=" width: 100px; text-align: center" placeholder="最小年龄" type="number" :precision="0" :min="1" :max="150" v-model="search.minAge"/>
					<a-input style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff" placeholder="~" disabled/>
					<a-input-number style="width: 100px; text-align: center;border-left:none;" placeholder="最大年龄" :precision="0" :min="search.minAge" :max="150"  type="number" v-model="search.maxAge" />
				</a-input-group>
			</a-form-model-item>
			<a-form-model-item label="状态">
				<a-select allowClear v-model="search.Enabled" placeholder="请选择状态" style="width:198px;">
					<a-select-option value="true">启用</a-select-option>
					<a-select-option value="false">禁用</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item>
				<a-button type="primary" @click="getList(1)">查询</a-button>
				<a-button style="margin: 0 35px 0 15px;" @click="resetSearch()">重置</a-button>
			</a-form-model-item>
			<a-form-model-item>
				<a-button @click="add()" type="primary" icon="plus" style="margin-left: 45px">添加问卷</a-button>
			</a-form-model-item>
		</a-form-model>
		<div class="table" style="margin-top:30px;">
			<a-table
				:columns="columns"
				rowKey="id"
				:pagination="tableRelevant.tablePagination"
				:loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
				<div slot="contentName" slot-scope="text,record">
                    <div class="table_div">
                        <a-icon type="exclamation-circle" theme="filled" class="table_icon" v-if="text.abnormalFlag > 0 && text.enabled"/>
                        {{text.contentName }}
                    </div>
                </div>
				<div slot="abilityTypeName" slot-scope="text">
					<div class="self_td" v-for="item in text.abilitys" :key="item.id">
						{{item.abilityTypeName}}-
						{{item.firstAbilityName}}-
						{{item.secondAbilityName}}
					</div>
				</div>
				<div slot="pushQuestionNum" slot-scope="text,record">
                    <span v-if="record.pushQuestionNum == 0">全部</span>
                    <span v-else>{{ record.pushQuestionNum }}</span>
                </div>
				<div slot="status" slot-scope="text,record">
                    <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click="StatusChange(record)"/>
                </div>
                <div slot="endTime" slot-scope="text,record">
                    {{ text.finishType === 1 ? "不限时" : text.endTime }}
                </div>
                <div slot="ages" slot-scope="text,record">
                    {{ record.minAge }} - {{ record.maxAge }}
                </div>
				<div slot="action" slot-scope="text,record" class="action">
					<a @click="edit(record)">
						<a-icon type="edit"/>
						编辑
					</a>
					<a-popconfirm title="确定删除？" @confirm="deleteEgame(record)">
						<a class="red">
							<a-icon type="delete"/>
							删除
						</a>
					</a-popconfirm>
					<a-dropdown>
						<a class="ant-dropdown-link">
							更多
							<a-icon type="down"/>
						</a>
						<a-menu slot="overlay">
							<a-menu-item>
								<a @click="question(record)">题目</a>
							</a-menu-item>
							<a-menu-item>
								<a @click="viewGame(text)">预览</a>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
				</div>
			</a-table>
		</div>
        <a-modal title="题目管理" :visible="Question.visible" @cancel="handleCancel" :footer="null" width="80%">
            <a-tabs :default-active-key="Question.currentTab" @change="changeTabs">
                <a-tab-pane key="1" tab="题目列表">
                    <div class="btns" style="position: relative;margin-bottom:15px;">
                        <a-button type="danger" style="margin-right:15px;" @click="batchDelete()">批量删除</a-button>
                        <a-button type="primary" style="margin-right:15px;" @click="addQuestion()">新建题目</a-button>
                        <a-button type="primary" style="margin-right:15px;" @click="openImport()">批量添加</a-button>
                        <a-popconfirm
                            style="margin-left: 15px"
                            title="是否设置自动排序？"
                            ok-text="确定"
                            cancel-text="取消"
                            @confirm="automaticsorting()">
                            <a-button type="primary" style="position: absolute;top: 0;right: 0;">自动排序</a-button>
                        </a-popconfirm>
                    </div>
                    <a-table
                        :columns="listColumns"
                        :scroll="{y: 350}"
                        :rowKey="record=> JSON.stringify(record)"
                        :row-selection="rowSelection"
                        :pagination="Question.tableRelevant.tablePagination"
                        :loading="Question.tableRelevant.tableLoading"
                        :locale="Question.tableRelevant.locale"
                        :dataSource="Question.tableRelevant.tableDataSource">
                        <div slot="name" slot-scope="text,record">
                            <div v-html="record.questionDto.name" class="name"></div>
                        </div>
                        <div slot="questionType" slot-scope="text,record">
                          {{ $data._questionType[record.questionDto.questionType] }}
                        </div>
                        <div slot="questionGroup" slot-scope="text,record">
                            <div>{{ record.questionDto.questionGroup }}</div>
                        </div>
                        <div slot="abilityTypeText" slot-scope="text,record">
                            <div>{{ record.questionDto.abilityTypeText }}</div>
                        </div>
                        <div slot="firstAbilityText" slot-scope="text,record">
                            <div>{{ record.questionDto.firstAbilityText }}</div>
                        </div>
                        <div slot="secondAbilityText" slot-scope="text,record">
                            <div>{{ record.questionDto.secondAbilityText }}</div>
                        </div>
                        <div slot="version" slot-scope="text,record">
                            <div>{{ record.questionDto.version }}</div>
                        </div>
                        <div slot="degreeOfDifficulty" slot-scope="text,record">
                            <div>{{ record.questionDto.degreeOfDifficulty }}</div>
                        </div>
                        <div slot="displayOrder" slot-scope="text, record">
                            <input @blur="tableInputBlurDisplayOrder($event,record)" oninput="if(value.length>3)value=value.slice(0,3)" class="table-input" type="number" :value="record.displayOrder"/>
                        </div>
                        <div slot="operation" slot-scope="text,record">
                            <a @click="editQuestion(record)">
                                编辑
                            </a>
                            <a-popconfirm
                                style="margin-left: 15px"
                                title="确定删除？"
                                ok-text="确定"
                                cancel-text="取消"
                                @confirm="deletequertionconfig(record)"
                            >
                                <a style="color: #f00;">
                                    <a-icon type="delete"/>
                                    删除
                                </a>
                            </a-popconfirm>
                            <a-dropdown style="margin-left: 15px">
                                <a class="ant-dropdown-link">
                                    更多
                                    <a-icon type="down"/>
                                </a>
                                <a-menu slot="overlay">
                                    <a-menu-item>
                                        <a class="noClick">关闭分页</a>
                                    </a-menu-item>
                                    <a-menu-item>
                                        <a @click="jumpFun(record)" v-if="(record.questionDto.questionType == 1 || record.questionDto.questionType == 3) && !record.questionItems.some(item => item.skipQuestionId)">跳转</a>
                                        <a @click="jumpFun(record)" style="color:#13c2c2;" v-if="(record.questionDto.questionType == 1 || record.questionDto.questionType == 3) && record.questionItems.some(item => item.skipQuestionId)">跳转</a>
                                        <a class="noClick" v-if="!(record.questionDto.questionType == 1 || record.questionDto.questionType == 3) && !record.questionItems.some(item => item.skipQuestionId)">跳转</a>
                                    </a-menu-item>
                                </a-menu>
                            </a-dropdown>
                        </div>
                    </a-table>
                </a-tab-pane>
                <a-tab-pane key="2" tab="题目配置">
                    <div class="m_search" style="margin-bottom:15px;">
                        <a-form-model layout="inline">
                          <a-form-model-item label="题目名称">
                            <a-input placeholder="请输入题目名称" v-model.trim="questionSet.data.name" :maxLength="35"/>
                          </a-form-model-item>
                            <a-form-model-item label="能力维度">
                                <a-cascader
                                    v-model="selectId"
                                    :options="options"
                                    :load-data="loadData"
                                    placeholder="请选择能力维度"
                                    change-on-select
                                    @change="onChangequestionSet"/>
                            </a-form-model-item>
                            <a-form-model-item label="题目分组">
                                <a-input placeholder="请输入题目分组" v-model="questionSet.data.questionGroup" @change="e => questionSet.data.questionGroup = e.target.value.replace(/\s*/g, '')" :maxLength="35"/>
                            </a-form-model-item>
                            <a-form-model-item label="题目ID">
                                <a-input placeholder="请输入题目ID" v-model="questionSet.data.questionid" @change="e => questionSet.data.questionid = e.target.value.replace(/\s*/g, '')" :maxLength="35"/>
                            </a-form-model-item>
                            <a-form-model-item label="难度系数">
                                <a-input-number placeholder="请输入难度系数" v-model="questionSet.data.difficulty" type="number" :min="0" :max="10" :step="0.1" style="width:175px;"/>
                            </a-form-model-item>
                            <a-form-model-item>
                                <a-button type="primary" @click="getQuestionsList('search')">查询</a-button>
                                <a-button style="margin: 0 35px 0 15px" type="primary" @click="questionSetAdd()">批量添加
                                </a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </div>
                    <a-table
                        :columns="questionSetColumns"
                        :scroll="{y: 350}"
                        :rowKey="record=> JSON.stringify(record)"
                        :row-selection="questionSetSelection"
                        :pagination="questionSet.tableRelevant.tablePagination"
                        :loading="questionSet.tableRelevant.tableLoading"
                        :locale="questionSet.tableRelevant.locale"
                        :dataSource="questionSet.tableRelevant.tableDataSource">
                        <div slot="name" slot-scope="text,record">
                            <div v-html="record.name" class="name"></div>
                        </div>
                        <div slot="questionType" slot-scope="text,record">
                          {{ $data._questionType[record.questionType] }}
                        </div>
                    </a-table>
                </a-tab-pane>
            </a-tabs>
        </a-modal>
        <a-modal v-model="upload.visible" title="批量导入题目" @ok="importOk">
            <template slot="footer">
                <a-button key="back" @click="cancelimportOk">取消</a-button>
                <a-button key="submit" type="primary" :loading="upload.importOkloading" @click="importOk">确定</a-button>
            </template>
            <div class="um-download">
                <h4 class="um-h4">数据模板下载</h4>
                <p align="center">
                    <a
                        :href="DownloadTemplate | filterUrl"
                        class="templateDownload"
                    >模板下载</a>
                </p>
            </div>
            <div class="um-download">
                <h4 class="um-h4">批量导入题目</h4>
            </div>
            <a-upload-dragger
                name="file"
                :file-list="upload.fileList"
                :remove="handleRemove"
                :before-upload="beforeUpload"
                @change="unploadChange"
            >
                <h4 class="um-upload">上传文件</h4>
                <p class="ant-upload-drag-icon">
                    <a-icon type="cloud-upload"/>
                </p>
                <p class="ant-upload-text" style="color: #666">点击上传文件，或将文件拖拽到此处</p>
                <p class="ant-upload-hint">（支持扩展名为xlsx文件）</p>
            </a-upload-dragger>
            <a
                @click="down()"
                v-if="upload.errorData.length" style="text-align: center; margin: 20px 0; display: block;color:#f00;"
            >点击这里下载错误数据</a>
        </a-modal>
        <a-modal title="跳转" :visible="isJump" @cancel="CancelJump" :footer="null" width="100%">
            <div class="jumptop">
                <div class="j_t_item">
                    <span>题目名称：</span>
                    <div v-html="jumpStr.name"></div>
                </div>
                <div class="j_t_item">
                    <ul>
                        <li>
                            <span>题目类型：</span>
                            <em>
                              {{ $data._questionType[jumpStr.questionType] }}
                            </em>
                        </li>
                        <li>
                            <span>一级能力：</span>
                            <em>{{ jumpStr.firstAbilityText }}</em>
                        </li>
                        <li>
                            <span>难度系数：</span>
                            <em>{{ jumpStr.degreeOfDifficulty }}</em>
                        </li>
                    </ul>
                </div>
                <div class="j_t_item">
                    <ul>
                        <li>
                            <span>能力类型：</span>
                            <em>{{ jumpStr.abilityTypeText }}</em>
                        </li>
                        <li>
                            <span>二级能力：</span>
                            <em>{{ jumpStr.secondAbilityText }}</em>
                        </li>
                    </ul>
                </div>
            </div>
            <a-table
                :loading="loading"

                :columns="jumpColumns"
                :data-source="jumpData"
                rowKey="id"
                class="components-table-demo-nested"
                :pagination="{
                    current: jump.pageIndex,
                    pageSize: jump.pageSize,
                    total: jumpTotal,
                    showSizeChanger: true,
                    showLessItems: true,
                    showQuickJumper: true,
                    showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
                    onChange: onjumpChange,
                    onShowSizeChange: onjumpSizeChange,
                }"
            >
                <div slot="option" slot-scope="text,record">
                    {{ record.itemTitle }}
                    <img :src="record.itemAttachmentUrl | filterUrl" style="width:28px;height:28px;" v-if="record.itemAttachmentUrl">
                </div>
                <div slot="jumpQuestion" slot-scope="text,record">
                    <span v-if="record.skipQuestionNo">{{ record.skipQuestionNo }} </span>
                    <a style="color: #13c2c2;cursor: pointer;" v-if="record.skipQuestionNo && record.skipQuestionId" @click="preview(record)">查看题目</a>
                </div>
                <div slot="operation" slot-scope="text,record">
                    <a @click="set(record)">
                        <a-icon type="edit"/>
                        设置
                    </a>
                    <a-popconfirm
                        v-if="record.skipQuestionNo && record.skipQuestionId"
                        style="margin-left: 15px"
                        title="确定删除？"
                        ok-text="确定"
                        cancel-text="取消"
                        @confirm="deleteSet(record)"
                    >
                        <a style="color: #f00;">
                            <a-icon type="delete"/>
                            删除
                        </a>
                    </a-popconfirm>
                </div>
            </a-table>
        </a-modal>
        <a-modal title="跳转设置" :visible="isJumpSet" @cancel="CanceljumpSet" :footer="null" width="100%">
            <div class="jumptop">
                <div class="j_t_item">
                    <span>题目名称：</span>
                    <div v-html="jumpStr.name"></div>
                </div>
                <div class="j_t_item">
                    <ul>
                        <li>
                            <span>题目类型：</span>
                            <em>{{ $data._questionType[jumpStr.questionType] }}</em>
                        </li>
                        <li>
                            <span>一级能力：</span>
                            <em>{{ jumpStr.firstAbilityText }}</em>
                        </li>
                        <li>
                            <span>难度系数：</span>
                            <em>{{ jumpStr.degreeOfDifficulty }}</em>
                        </li>
                    </ul>
                </div>
                <div class="j_t_item">
                    <ul>
                        <li>
                            <span>能力类型：</span>
                            <em>{{ jumpStr.abilityTypeText }}</em>
                        </li>
                        <li>
                            <span>二级能力：</span>
                            <em>{{ jumpStr.secondAbilityText }}</em>
                        </li>
                    </ul>
                </div>
            </div>
            <template>
                <a-table
                    :loading="loading"
                    :columns="jumpSetColumns"
                    :data-source="jumpSetData"
                    rowKey="id"
                    class="components-table-demo-nested"
                    :pagination="{
                        current: Question.tableRelevant.tablePagination.current,
                        pageSize: Question.tableRelevant.tablePagination.pageSize,
                        total: jumpSet.total,
                        showSizeChanger: true,
                        showLessItems: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
                        onChange: onjumpSetChange,
                        onShowSizeChange: onjumpSetSizeChange,
                    }"
                >
                    <div slot="name" slot-scope="text,record">
                        <div v-html="record.questionDto.name" class="name"></div>
                    </div>
                    <div slot="questionType" slot-scope="text,record">
                      {{ $data._questionType[record.questionDto.questionType] }}
                    </div>
                    <div slot="questionGroup" slot-scope="text,record">
                        <div>{{ record.questionDto.questionGroup }}</div>
                    </div>
                    <div slot="abilityTypeText" slot-scope="text,record">
                        <div>{{ record.questionDto.abilityTypeText }}</div>
                    </div>
                    <div slot="firstAbilityText" slot-scope="text,record">
                        <div>{{ record.questionDto.firstAbilityText }}</div>
                    </div>
                    <div slot="secondAbilityText" slot-scope="text,record">
                        <div>{{ record.questionDto.secondAbilityText }}</div>
                    </div>
                    <div slot="version" slot-scope="text,record">
                        <div>{{ record.questionDto.version }}</div>
                    </div>
                    <div slot="degreeOfDifficulty" slot-scope="text,record">
                        <div>{{ record.questionDto.degreeOfDifficulty }}</div>
                    </div>
                    <div slot="operation" slot-scope="text,record,index">
                        <span v-if="record.questionId == questionId">当前题目</span>
                        <a-radio :checked="radioIndex === record.id || record.questionId === skipQuestionId" @change="changeRadio(index,record)" v-else></a-radio>
                    </div>
                </a-table>
            </template>
            <div class="subBtn">
                <a-button type="primary" @click="subJumpSet()">保存</a-button>
            </div>
        </a-modal>
	</a-card>
</template>

<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import xlsx from "xlsx-js-style";

const columns = [
    {title: '问卷名称', scopedSlots: { customRender: 'contentName' }, fixed: 'left', width: 300},
    {
        title: '能力类型',
        class: 'testClass',
		width: 250,
        key: 'abilityTypeName',
        align: 'center',
        scopedSlots: {customRender: 'abilityTypeName'}
    },
    {title: '取题数量', scopedSlots: {customRender: 'pushQuestionNum'}, key: 'pushQuestionNum', align: 'center',},
    {title: '题目数量', dataIndex: 'questionCount', key: 'questionCount', align: 'center',},
    {title: '结束时长', scopedSlots: {customRender: 'endTime'}},
    {title: '关联课程', scopedSlots: {customRender: 'courseCount'}, align: 'center',},
    {
        title: '年龄段',
        scopedSlots: {customRender: 'ages'},
        align: 'center',
        key: 'createTime'
    },
    {
        title: '状态',
        key: 'status',
        align: 'center',
        scopedSlots: {customRender: 'status'},
    },
    {title: '更新时间', dataIndex: 'updateTime', align: 'center', key: 'updateTime'},
    {
        title: '操作',
        key: 'action',
        align: 'center',
        width: 220,
        scopedSlots: {customRender: 'action'},
        fixed: 'right',
    },
];
const listColumns = [
    {title: '题目名称', scopedSlots: {customRender: 'name'}, width: 200, ellipsis: true, align: 'center',},
    {title: '题目类型', scopedSlots: {customRender: 'questionType'}, align: 'center',},
    {title: '题目分组', scopedSlots: {customRender: 'questionGroup'}, align: 'center',},
    {title: '能力类型', scopedSlots: {customRender: 'abilityTypeText'}, align: 'center',},
    {title: '一级能力', scopedSlots: {customRender: 'firstAbilityText'}, align: 'center',},
    {title: '二级能力', scopedSlots: {customRender: 'secondAbilityText'}, align: 'center',},
    {title: '版本', scopedSlots: {customRender: 'version'}, align: 'center',},
    {title: '难度系数', scopedSlots: {customRender: 'degreeOfDifficulty'}, align: 'center',},
    {title: '排序', scopedSlots: {customRender: 'displayOrder'}, align: 'center',},
    {
        title: '操作',
        width: 200,
        align: 'center',
        scopedSlots: {customRender: 'operation'},
    },
]
const questionSetColumns = [
    {title: '题目名称', scopedSlots: {customRender: 'name'}, width: 200, ellipsis: true, align: 'center'},
    {title: '题目类型', scopedSlots: {customRender: 'questionType'}, align: 'center',},
    {title: '题目分组', dataIndex: 'questionGroup', align: 'center',},
    {title: '能力类型', dataIndex: 'abilityTypeText', align: 'center',},
    {title: '一级能力', dataIndex: 'firstAbilityText', align: 'center'},
    {title: '二级能力', dataIndex: 'secondAbilityText', align: 'center',},
    {title: '版本', dataIndex: 'version', align: 'center',},
    {title: '难度系数', dataIndex: 'degreeOfDifficulty', align: 'center',},
]
const jumpColumns = [
    {title: '选项', scopedSlots: {customRender: 'option'}, width: 200, ellipsis: true, align: 'center'},
    {title: '分值', dataIndex: 'score', align: 'center'},
    {title: '排序', dataIndex: 'displayOrder', align: 'center'},
    {title: '跳转题目', scopedSlots: {customRender: 'jumpQuestion'}, align: 'center'},
    {title: '操作', align: 'center', scopedSlots: {customRender: 'operation'}},
]
const jumpSetColumns = [
    {title: '题目名称', scopedSlots: {customRender: 'name'}, width: 200, ellipsis: true, align: 'center'},
    {title: '题目类型', scopedSlots: {customRender: 'questionType'}, align: 'center',},
    {title: '能力类型', scopedSlots: {customRender: 'abilityTypeText'}, align: 'center',},
    {title: '一级能力', scopedSlots: {customRender: 'firstAbilityText'}, align: 'center'},
    {title: '二级能力', scopedSlots: {customRender: 'secondAbilityText'}, align: 'center',},
    {title: '版本', scopedSlots: {customRender: 'version'}, align: 'center',},
    {title: '难度系数', scopedSlots: {customRender: 'degreeOfDifficulty'}, align: 'center',},
    {title: '操作', align: 'center', scopedSlots: {customRender: 'operation'}},
]
export default {
	naem:'QuestionnaireManage',
	data(){
		return{
            DownloadTemplate: process.env.VUE_APP_TEMPLATE_URL + '/template/excel/Question_Import_Template.xlsx',
			columns,
			options: [],
            selectId: [],
			search: {
                ContentType: 6,
                Name: '',
                AbilityTypeId: '',
                FirstAbilityId: '',
                SecondAbilityId: '',
                Enabled: undefined,
                minAge:undefined,
		        maxAge:undefined,
            },
			tableRelevant: tableRelevant.call(this,this.getList),

            deleteList:[],
            addList:[],

            listColumns,
            Question:{
                id:'',
                visible:false,
                tableRelevant: tableRelevant.call(this,this.getQuestionSetList),
                currentTab:'1',
                data:[],
                selectedRows:[]
            },
            questionSetColumns,
            questionSet:{
                data:{
                    name: undefined,
                    groupId: '',
                    questionGroup: "",
                    difficulty: '',
                    questionid: '',
                    AbilityTypeId: "",
                    FirstAbilityId: "",
                    SecondAbilityId: ""
                },
                tableRelevant: tableRelevant.call(this,this.getQuestionsList),
                selectedRows:[]
            },
            upload:{
                visible:false,
                importOkloading: false,
                baseURL: process.env.VUE_APP_API_BASE_URL,
              errorData: [],
                fileList: [],
                file: "",
            },
            loading: true,
            isJump: false,//跳转
            jumpStr: {},
            jump: {
                pageIndex: 1,
                pageSize: 10,
            },
            jumpColumns,
            jumpData: [],
            jumpTotal: 0,
            questionId: '',
            isJumpSet: false,//跳转设置
            jumpSet: {
                pageIndex: 1,
                pageSize: 10,
                total: 0
            },
            jumpSetColumns,
            jumpSetData: [],
            radioIndex: -1,
            QuestionItemId: '',//题目选项id
            skipId: '',//题目选项skipId
            skipQuestionId: '',
            jumpSetParams: {},
            num: 0,
		}
	},
    computed: {
        rowSelection() {
            return {
                selectedRowKeys: this.Question.selectedRows,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.Question.selectedRows = selectedRowKeys;
                    this.deleteList = selectedRowKeys
                }
            };
        },
        questionSetSelection() {
            return {
                selectedRowKeys: this.questionSet.selectedRows,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.questionSet.selectedRows = selectedRowKeys;
                    this.addList = this.questionSet.selectedRows
                }
            };
        },
    },
	mounted(){
		this.abilityTypeSelect(0)
		this.getList(1)
	},
	methods:{
		getList(pageIndex){
			let params = {
				...this.search,
				pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                pageSize: this.tableRelevant.tablePagination.pageSize,
			}
			this.tableRelevant.tableLoading = true;
			this.$http.questiongrouppagelist(params)
			.then(res =>{
				const {status, data, message} = res.data;
				this.tableRelevant.tableLoading = false;
					this.tableRelevant.tableDataSource = data.items
					this.tableRelevant.tablePagination.total = data.totalCount
					this.tableRelevant.tablePagination.current = data.pageIndex;
			
			})
		},
		loadData(selectedOptions) {
            return new Promise((resolve, reject) => {
                const targetOption = selectedOptions[selectedOptions.length - 1];
                targetOption.loading = true;
                targetOption.children = [];
                let params = {
                    pid: targetOption.id,
                    abilityType:0
                };
                this.$http.abilitySelect(params).then(res => {
                        targetOption.loading = false;
                        targetOption.children = res.data.data.map(m => ({...m, value: m.id,label: m.name,isLeaf: m.levelNumber > 1}))
                        this.options = [...this.options];
                        resolve(targetOption.children)
                });
            })
        },
        abilityTypeSelect(level) {
            let params = {
                level: level,
                abilityType: 0
            };
            this.$http.abilitySelect(params)
                .then(res => {
                        this.options = res.data.data
                        this.options.forEach(item => {
                            item.value = item.id
                            item.label = item.name
                            item.isLeaf = false
                        })
                        if (this.search.AbilityTypeId){
                            this.loadData(this.options.filter(f => f.id === this.search.AbilityTypeId)).then(data => {
                                if (this.search.FirstAbilityId){
                                    this.loadData(data.filter(f => f.id === this.search.FirstAbilityId))
                                }
                            })
                        }
                });
        },
		onChange(value) {
            this.search.AbilityTypeId = value[0]
            this.search.FirstAbilityId = value[1]
            this.search.SecondAbilityId = value[2]
            this.selectId = value
        },
        onChangequestionSet(value) {
            this.questionSet.data.AbilityTypeId = value[0]
            this.questionSet.data.FirstAbilityId = value[1]
            this.questionSet.data.SecondAbilityId = value[2]
        },

		add(){
			this.$store.commit("content/setQuestionnaireInfo", "");
            this.$router.push({
                path: '/content/QuestionnaireManage/QuestionnaireSeting',
                query: {
                    type: "add",
                    contentType: 6
                }
            })
		},
		edit(record){
			this.$store.commit("content/setQuestionnaireInfo", {fullPath: this.$route.fullPath, ...record})
            sessionStorage.setItem("currentId", record.id);//id
            sessionStorage.setItem("currentName", record.contentName);//name
            sessionStorage.setItem("currentRecord", JSON.stringify(record));//name
            this.$router.push({
                path: '/content/QuestionnaireManage/QuestionnaireSeting',
                query: {
                    type: "edit",
                    contentType: this.search.ContentType,
                    contentName: record.contentName,
                    versionName: record.versionName,
                }
            })
		},
        deleteEgame(record) {
            this.$confirm({
                title: `确认删除【${record.contentName}】`,
                content: "问卷删除后所有相关数据都将删除且不可恢复，请谨慎操作",
                centered: true,
                onOk: () => {
                    let formData = new FormData();
                    formData.append('contentId', record.id);
                    this.loading = true;
                    this.$http.deleteEGamege(formData).then(res => {
                        this.loading = false;
                            this.getList(1);
                            this.$message.success('删除成功');
                        
                    });
                }
            });
        },
        StatusChange(record) {
            this.$message.destroy();
            const fn = () => {
                let formData = new FormData();
                formData.append('id', record.id);
                this.loading = true;
                this.$http.updatestatus(formData).then(res => {
                    this.loading = false;
                        record.enabled = !record.enabled;
                        this.$message.success('修改成功');

                   
                });
            };
            if (record.enabled) {
                this.$confirm({
                    title: `确认禁用【${record.contentName}】`,
                    content: "问卷禁用后，已配置的课程将移除该题目壳且不可恢复，请谨慎操作",
                    centered: true,
                    onOk: fn
                });
                return
            }
            let formData = new FormData();
            formData.append("id", record.id);
            formData.append("enabled", false);
            this.$http.contentCheckStatus(formData).then(res => {
                    fn();
             
            });
        },
        resetSearch() {
            this.search = {
                ContentType: 6,
                Name: '',
                AbilityTypeId: '',
                FirstAbilityId: '',
                SecondAbilityId: '',
                Enabled: undefined,
                minAge:undefined,
		        maxAge:undefined,
            }
            this.getList()
        },

        // 题目设置
        question(record) {
            this.Question.visible = true;
            this.Question.id = record.id;
            this.getQuestionSetList('question');
            this.getQuestionsList();
        },
        handleCancel(){
            this.Question.visible = false;
          for (let dataKey in this.questionSet.data) {
            this.questionSet.data[dataKey] = undefined
          }
        },
        // 切换tab
        changeTabs(key) {
            this.questionSet.selectedRows = []
            if (key == 1) {
                this.getQuestionSetList()
            } else if (key == 2) {
                this.getQuestionsList()
            }
        },
        getQuestionSetList(type) {
            let params = {
                pageIndex: this.Question.tableRelevant.tablePagination.current,
                pageSize: this.Question.tableRelevant.tablePagination.pageSize,
                questionGroupId: this.Question.id,
            }
            this.Question.tableRelevant.tableLoading = true;
            this.$http.getquestionbyidlist(params)
            .then(res => {
                this.Question.tableRelevant.tableLoading = false;
                const {status, data, message} = res.data;
                    if (type == 'question') {
                        this.Question.tableRelevant.tableDataSource = data.items
                        this.Question.tableRelevant.tablePagination.total = data.totalCount
                        this.Question.tableRelevant.tablePagination.current = data.pageIndex;
                    }
                    if (type == 'set') {
                        this.jumpSetData = res.data.data.items
                        this.jumpSet.total = res.data.data.totalCount
                    }
              
            });
        },
        // 删除
        deletequertionconfig(record) {
            let query = [record.id]
            this.$http.deletequertionconfig(query)
            .then(res => {
                    this.$message.success('删除成功')

                    this.getQuestionSetList('question')
            });
        },
        // 批量删除
        batchDelete() {
            let _this = this;
            if (!_this.deleteList.length) {
                this.$message.destroy();
                this.$message.warning("请选择");
                return;
            }
            this.$confirm({
                title: "提示",
                content: `一共选中 ${_this.deleteList.length} 个游戏，确定删除？`,
                onOk() {
                    _this.batchDeleteFun();
                },
                onCancel() {
                    console.log("Cancel");
                }
            });
        },
        // 批量删除方法
        batchDeleteFun() {
            let arr = []
            this.deleteList.forEach((el, index) => {
                let item = JSON.parse(el)
                arr.push(item.id)
            });
            this.$http.deletequertionconfig(arr)
                .then(res => {
                        this.$message.success('删除成功')
                        this.getQuestionSetList('question')
                        this.deleteList = []
                        this.Question.selectedRows = []
                });
        },
        // 新建题目
        addQuestion() {
            this.$store.commit("content/setQuestionnaireInfo", {routerName: '问卷管理', fullPath: this.$route.fullPath});
            this.$router.push({
                path: "/content/Question/QuestionSeting",
                query: {
                    type: "add",
                    contentType: 6,
                    questionGroupId: this.Question.id
                }
            })
        },
        // 编辑题目
        editQuestion(record) {
            sessionStorage.setItem('editquestion', record.questionDto.id);
            sessionStorage.setItem('editquestionModal', JSON.stringify(record))

            this.$store.commit("content/setQuestionnaireInfo", {routerName: '问卷管理', fullPath: this.$route.fullPath, ...record})
            this.$router.push({
                path: "/content/Question/QuestionSeting",
                query: {
                    id: record.questionDto.id
                }
            });
        },
        handleRemove(file) {
            const index = this.upload.fileList.indexOf(file);
            const newFileList = this.upload.fileList.slice();
            newFileList.splice(index, 1);
            this.upload.fileList = newFileList;
        },
        beforeUpload(file) {
            const bool = this.upload.fileList.filter(v => v.name === file.name).length;
            if (bool) {
                this.$message.warning("已有相同的文件，请重新选择文件");
                return false;
            }
            this.upload.fileList = [file];
            return false;
        },
        unploadChange(value) {
            if (value.fileList.length) {
                this.upload.file = value.file;
            } else {
                this.upload.file = "";
            }
        },
        openImport() {
            this.upload.visible = true
        },
        cancelimportOk() {
          this.upload.errorData = [];
            this.upload.visible = false
        },
        // 批量导入提交
        importOk() {
            if (this.upload.file) {
                this.upload.importOkloading = true
                const formData = new FormData();
                formData.append("excelfile", this.upload.file);
                formData.append("QuestionGroupId", this.Question.id);
                this.uploadF(formData);
            } else {
                this.$message.destroy();
                this.$message.warning("请选择xlsx文件");
            }
        },
    uploadF(formData) {
      this.$http.questionsImport(formData).then(res => {
        this.$message.success(res.message);
        this.getQuestionSetList("question");
        this.upload.fileList = [];
        this.upload.errorData = [];
        this.upload.file = "";
        this.resetForm();
      }).catch(e => {
        if (e.errors) {
          this.upload.errorData = e.errors;
          this.upload.fileList = [];
          this.upload.file = "";
          this.getQuestionSetList("question");
        }
      }).finally(() => {
        this.importOkloading = false;
      })
    },
    // 下载错误原因
    down() {
      const merges = [{s: {r: 0, c: 0}, e: {r: 0, c: 10}}];
      let titleList1 = ["题目", "", "", "", "", "", "", "", "", "", ""];
      let titleList2 = ["题目名称", "题目分组", "题目类型", "题目版本", "题目难度系数", "题目能力类型", "题目一级能力", "题目二级能力", "题目备注说明", "题目解析", "题目附件"];
      const list = this.upload.errorData.map((m, i) => {
        let data = [
          m.name,
          m.questionGroup,
          this.$data._questionType[m.questionType],
          m.version,
          m.degreeOfDifficultyText,
          m.abilityTopText,
          m.firstAbilityText,
          m.secondAbilityText,
          m.remark,
          m.analysis,
          m.attachmentUrl,
        ];
        m.questionItems.forEach((f, i2) => {
          data = data.concat([
            f.itemTitle,
            f.scoreText,
            f.isRightChoiceText,
            f.displayOrderText,
            f.jumpQuestionNOText,
            f.itemAttachmentUrl,
          ])
          if (i === 0) {
            merges.push({s: {r: 0, c: 10 + (i2 * 6) + 1}, e: {r: 0, c: 10 + ((i2 + 1) * 6)}})
            titleList1 = titleList1.concat(["选项" + (i2 + 1), "", "", "", "", ""]);
            titleList2 = titleList2.concat(["选项标题", "选项分值", "是否正确答案", "显示顺序", "跳转题目编号", "选项附件"]);
          }
        });
        data.push(m.messageList.join('\n'))
        return data;
      });
      // 添加错误信息列
      titleList1.push("错误信息");
      titleList2.push("");
      merges.push({s: {r: 0, c: titleList2.length - 1}, e: {r: 1, c: titleList2.length - 1}})
      // 创建一个新的工作簿
      const workbook = xlsx.utils.book_new();
      // 将数据转换为工作表
      const worksheet = xlsx.utils.aoa_to_sheet([titleList1, titleList2].concat(list));
      const cols = [];
      // 设置内容样式
      Object.keys(worksheet).forEach(f => {
        if (typeof worksheet[f] !== 'object') {
          return;
        }
        worksheet[f].s = {
          font: {
            sz: 12,
            color: { rgb: '000000' }
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          }
        };
      });
      // 设置表头样式
      titleList2.forEach((f, i) => {
        const ex0 = xlsx.utils.encode_cell({ r: 0, c: i });
        const ex1 = xlsx.utils.encode_cell({ r: 1, c: i });
        const obj = {
          font: {
            sz: 12,
            bold: true,
            color: { rgb: worksheet[ex0].v === '错误信息' ? 'FF0000' : '000000' }
          },
          fill: {
            fgColor: { rgb: 'eeeeeeff' } // 背景
          },
          border: {
            top: { style: 'thin', color: { rgb: '000000' } }, // 上边框
            bottom: { style: 'thin', color: { rgb: '000000' } }, // 下边框
            left: { style: 'thin', color: { rgb: '000000' } }, // 左边框
            right: { style: 'thin', color: { rgb: '000000' } } // 右边框
          },
          alignment: {
            horizontal: 'center',
            vertical: 'center'
          }
        }
        worksheet[ex0].s = obj;
        worksheet[ex1].s = obj;
        // 设置列宽
        cols.push({ wpx: worksheet[ex0].v === '错误信息' ? 250 : 120 });
      })
      // 设置列宽
      worksheet['!cols'] = cols;
      // 设置行高
      worksheet['!rows'] = list.map(m => ({ hpt: 23 }));
      // 设置合并单元格
      worksheet['!merges'] = merges;
      // 将工作表添加到工作簿中
      xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      // 将工作簿导出为 Excel 文件
      xlsx.writeFile(workbook, '导入题目错误数据.xlsx');
    },
        jumpFun(record) {
            this.isJump = true
            this.isQuestion = false
            this.jumpStr = record.questionDto
            this.questionId = record.questionId
            this.getOptionsList()
        },
        getOptionsList() {
            let params = {
                pageIndex: this.jump.pageIndex,
                pageSize: this.jump.pageSize,
                questionGroupId: this.Question.id,
                questionId: this.questionId
            }
            this.$http.getquestionitemsbyid(params)
                .then(res => {
                    this.loading = false
                        this.jumpData = res.data.data.items
                        this.jumpTotal = res.data.data.totalCount
                });
        },
        // 关闭跳转
        CancelJump() {
            this.isJump = false
            this.isQuestion = true
            this.getQuestionSetList('question')
        },
        // 设置
        set(record) {
            this.isJumpSet = true
            this.isJump = false
            this.QuestionItemId = record.id
            this.skipId = record.skipId
            if (record.skipQuestionNo && record.skipQuestionId) {
                this.skipQuestionId = record.skipQuestionId
                sessionStorage.setItem('skipQuestionId', this.skipQuestionId)
            } else {
                this.skipQuestionId = ''
            }

            this.getQuestionSetList('set')
        },
        // 删除设置
        deleteSet(record) {
            console.log(record)
            let formData = new FormData()
            formData.append('id', record.skipId)
            this.$http.deleteskip(formData)
                .then(res => {
                        this.$message.success('删除成功')
                        sessionStorage.removeItem('skipQuestionId')
                        this.radioIndex = -1
                        this.getOptionsList()
                   
                });
        },
        // 关闭设置
        CanceljumpSet() {
            this.isJumpSet = false
            this.isJump = true
            //   this.skipQuestionId =  sessionStorage.getItem('skipQuestionId')
            this.skipQuestionId = ''
            this.radioIndex = -1
            this.jumpSetParams = {}
        },
        // 点击单选
        changeRadio(index, record) {
            console.log(record)
            this.skipQuestionId = -9999
            this.radioIndex = record.id
            this.jumpSetParams = {
                QuestionGroupId: record.questionGroupId,
                QuestionId: this.questionId,
                QuestionItemId: this.QuestionItemId,
                SkipQuestionId: record.questionId,
                Id: this.skipId == 0 ? '' : this.skipId,
            }
            // this.subJumpSet(params)
        },
        // 查看题目
        preview(record) {
            console.log(record);
            this.$http.questionDetail({id: record.skipQuestionId})
                .then(res => {
                        console.log(res)
                        this.qusetionItem = res.data.data
                        this.ispreview = true
                        this.num = record.questionItems.filter(item => {
                            return item.itemType == 0
                        })
                });
        },
        // 保存跳转设置
        subJumpSet() {
            let formData = new FormData()
            for (let key in this.jumpSetParams) {
                formData.append(key, this.jumpSetParams[key])
            }
            this.$http.editskip(formData)
                .then(res => {
                    this.$message.destroy();
                        this.$message.success(res.data.message)
                        this.isJumpSet = false
                        this.isJump = true
                        this.getOptionsList()
                   
                });
        },
        // 排序
        tableInputBlurDisplayOrder(e, record) {
            let formData = new FormData()
            formData.append('id', record.id)
            formData.append('displayOrder', e.target.value)
            this.$http.updateorder(formData)
                .then(res => {
                        this.$message.success('操作成功')
                        this.getQuestionSetList('question')
                });
        },
        // 自动排序
        automaticsorting() {
            let formData = new FormData()
            formData.append('id', this.Question.id)
            this.$http.automaticsorting(formData)
            .then(res => {
                    this.$message.success('操作成功')
                    this.getQuestionSetList('question')
            });
        },

        // 题目配置列表
        getQuestionsList(query) {
            let params = {
                AbilityTypeId: this.search.AbilityTypeId,
                FirstAbilityId: this.search.FirstAbilityId,
                SecondAbilityId: this.search.SecondAbilityId,
                pageIndex:this.questionSet.tableRelevant.tablePagination.current,
                pageSize:this.questionSet.tableRelevant.tablePagination.pageSize,
                status: true,
            }
            if (query) {
                this.questionSet.tableRelevant.tablePagination.current = 1;
                params = {}
            }
            this.questionSet.data.groupId = this.Question.id
            for (let key in this.questionSet.data) {
                if (this.questionSet.data[key]) {
                    params[key] = this.questionSet.data[key]
                }
            }
            this.questionSet.tableRelevant.tableLoading = true;
            this.$http.questionsList(params).then(res => {
                const {status, data, message} = res.data;
                this.questionSet.tableRelevant.tableLoading = false;

                    this.questionSet.tableRelevant.tableDataSource = data.items
                    this.questionSet.tableRelevant.tablePagination.total = data.totalCount
                    this.questionSet.tableRelevant.tablePagination.current = data.pageIndex;
              
            });
        },
        questionSetAdd() {
            let _this = this;
            if (!_this.addList.length) {
                this.$message.destroy();
                this.$message.warning("请选择题目");
                return;
            }
            this.$confirm({
                title: "提示",
                content: `一共选中 ${_this.addList.length} 个题目，确定添加？`,
                onOk() {
                    _this.addFun();
                },
                onCancel() {
                    console.log("Cancel");
                }
            });
        },
        addFun() {
            let formData = new FormData()
            let str = {
                displayOrder: '',
                questionGroupId: '',
                questionId: ''
            }
            this.addList.forEach((el, index) => {
                let item = JSON.parse(el)
                item.questionGroupId = this.Question.id
                item.questionId = item.id
                item.displayOrder = 0
                for (let key in item) {
                    for (let k in str) {
                        if (key == k) {
                            formData.append(`models[${index}][${key}]`, item[key]);
                        }
                    }
                }
            })
            this.$http.addquestionconfig(formData)
                .then(res => {
                        this.$message.success('添加成功')
                        this.Question.tableRelevant.tablePagination.current = 1
                        this.questionSet.tableRelevant.tablePagination.current = 1
                        this.getQuestionSetList('question')
                        this.getQuestionsList()
                        this.addList = []
                        this.questionSet.selectedRows = []
                });
        },
        viewGame(record) {
            let APIURL = (process.env.VUE_APP_API_BASE_URL).replace(/^http(s)?:\/\/(.*?)/, "");
            console.log(APIURL)
            let url = ''
            if (record.versions[0].uri) {
                if (record.versions[0].uri.indexOf('http') < 0) {
                    url = "http://" + record.versions[0].uri
                } else {
                    url = record.versions[0].uri
                }
                window.open(url + '?questionGroupId=' + record.id + '&url=' + APIURL);
            } else {
                window.open('');
            }
        },

        onjumpChange(pageIndex, size) {
            this.jump.pageIndex = pageIndex;
            this.getOptionsList()
        },
        onjumpSizeChange(pageIndex, size) {
            this.jump.pageIndex = 1;
            this.jump.pageSize = size;
            this.getOptionsList()
        },
        onjumpSetChange(pageIndex, size) {
            this.Question.tableRelevant.tablePagination.current = pageIndex;
            this.getQuestionSetList('set')
        },
        onjumpSetSizeChange(pageIndex, size) {
            this.Question.tableRelevant.tablePagination.current = 1;
            this.Question.tableRelevant.tablePagination.pageSize = size;
            this.getQuestionSetList('set')
        },
	}
}
</script>

<style lang="less" scoped>
.table_div{
  display: flex;
  align-items: center;
}
.table_icon{
  color:#ff9904;
  font-size:24px;
  margin-right: 5px;
}
/deep/ .ant-table-tbody .testClass {
    padding: 0 !important;
}

.self_td {
    height: 54px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: center;
}
.table_div{
  display: flex;
  align-items: center;
}
.table_icon{
  color:#ff9904;
  font-size:24px;
  margin-right: 5px;
}
/deep/ .ant-table-tbody .testClass {
    padding: 0 !important;
}

.self_td {
    height: 54px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    justify-content: center;
}

.name {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.noClick {
    color: #ccc;
    cursor: not-allowed;
}

.jumptop {
    width: 100%;
    padding: 15px 15px 0 15px;
    background: #f2f2f2;
    display: flex;
    justify-content: space-around;
    margin-bottom: 15px;

    .j_t_item {
        ul {
            margin: 0;

            li {
                list-style: none;
                margin-bottom: 15px;

                em {
                    font-style: normal;
                }
            }
        }
    }
}

.subBtn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
}

.m_search {
    padding-left: 30px;
}

.viewUl {
    padding: 0;
    border: 1px solid #e6e6e6;
    border-top: 0;

    li {
        list-style: none;
        border-top: 1px solid #e6e6e6;
        display: flex;
        align-items: center;
        padding: 5px 15px;
        min-height: 53px;

        span {
            margin: 0 30px;
        }

        img {
            margin-left: 100px;
            width: 100px;
        }
    }

    .viewpick {
        background: #f2f2f2;
    }

    .bot_t {
        display: flex;
        background: #f2f2f2;

        li {
            flex: 1 1 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #e6e6e6;
            min-height: 53px;

            span {
                margin: 0;
            }
        }

        li:last-child {
            border-right: 0;
        }
    }

    .bot_b {
        li {
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 53px;

            span {
                min-height: 53px;
                display: flex;
                margin: 0;
                flex: 1 1 0;
                justify-content: center;
                align-items: center;
                border-right: 1px solid #e6e6e6;
            }

            span:last-child {
                border-right: 0;
            }
        }
    }
}

.table-input {
    border: none;
    width: 100%;
    height: 100%;
    display: block;
    background: transparent;
    outline: none;
    text-align: center;
}

input[type=number] {
    -moz-appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.dImg {
    width: 100%;
}

.top img {
    max-width: 100%;
}

.qusetion-box {
    height: 500px;
    overflow-y: auto;
}
</style>
